module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }